import { API, Auth } from 'aws-amplify';
import React, { FC, useEffect, useState, useRef } from 'react';
import Slider from 'react-slick';
import { useParams } from 'react-router';
import { RootState, useDispatch, useSelector } from 'src/store';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    multi_image: [
      'shop now - image1',
      'shop now - image2',
      'shop now - image3'
    ],
    multi_left_button: [
      'close - button1',
      'close - button2',
      'close - button3'
    ],
    multi_right_button: [
      'shop now - button1',
      'shop now - button2',
      'shop now - button3'
    ]
  }
};

const SimpleModalSlideTracking: FC = () => {
  var currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  var tracking = useSelector((state: RootState) => state.trackings.tracking);

  const style = `
  .root_tracking {
    width: 100%;
    height: 100%;

    overflow: hidden;
    position: relative;
    background: none;
    
    .modal_wrapper {
      width: 100%;
      min-height: 468px;

      display: flex;
      flex-direction: column;
      gap: 1rem;

      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);
      
      overflow: hidden;
      background: transparent;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list,
    .slick_wrapper .slick-track div,
    .slick_wrapper .slick-track img {
      width: 100%;
      min-height: 288px;
      outline: none;
    }
    .slick_wrapper .slick-track img {
      object-fit: cover;
    }

    .slick_wrapper .image_box {
      width: 100%;
      height: 100%;
      position: relative;
    }
    .image_box .title_box {
      width: 100%;
      height: 5.875rem;
      padding: 1rem;

      position: absolute;
      bottom: 0;
      z-index: 1;
    }
    .image_box .title {
      width: 100%;
      height: 1.5rem;
      margin-bottom: 0.5rem;
    }
    .image_box .sub_title {
      width: 100%;
      height: 1.75rem;

      display: flex;
      align-items: center;
    }

    .contents_wrapper,
    .contents_box .title {
      height: 4.5rem;
    }
    .contents_box {
      height: 4.5rem;
      padding: 0 1.5rem;
    }
    .contents_box .title {
      width: 100%;
      height: 4.5rem;
      display: flex;
      align-items: center;
    }

    .dot_wrapper {
      margin-top: 1rem;
    }
    .dot_wrapper,
    .dot_wrapper li {
      height: 0.25rem;      
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      list-style-type: none;
    }
    .dot_wrapper button {
      width: 0.25rem;
      height: 0.25rem;

      font-size: 0;
      border: 0;
      outline: 0;
      border-radius: 999px;
      background-color: rgba(0, 0, 0, .3);
    }
    .dot_wrapper li.slick-active button {
      background-color: #000;
    }

    .bar_blank {
      width: 100%;
      height: 0.25rem;
    }
    .btn_wrapper {
      width: 100%;
      height: 2.5rem;
    //   margin-bottom: 1rem;
    }
    .btn_inner {
      height: 40px;
    }

    .tracking_center {
        display: flex;
        align-items: center;
        justify-content: end;
    }
  }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_tracking">
        <div className="modal_wrapper">
          <div className="slick_wrapper tracking_center">
            <EditTracking
              value={tracking?.multi_image?.[currentIndex]}
              type="multi_image"
            />
          </div>
          <div className="contents_wrapper"></div>
          {/* <div className="bar_blank" /> */}
          <div className="btn_wrapper">
            <div className="btn_inner tracking_center">
              <EditTracking
                value={tracking?.multi_left_button?.[currentIndex]}
                type="multi_left_button"
              />
            </div>
            <div className="btn_inner tracking_center">
              <EditTracking
                value={tracking?.multi_right_button?.[currentIndex]}
                type="multi_right_button"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SimpleModalSlideTracking;
